import { NgModule } from '@angular/core';

import { LOCALE_ID } from '@angular/core';
import { registerLocaleData  } from '@angular/common';
import localeEs from '@angular/common/locales/es-AR';
import localeExtraEs from '@angular/common/locales/extra/es-AR';

// Locale
const CURRENT_LOCALE_ID = 'es-AR';
const PROVIDERS = [
  { provide: LOCALE_ID, useValue: CURRENT_LOCALE_ID },
];
@NgModule({
  imports: [],
  providers: [PROVIDERS],
})
export class AppSettingsModule {
  constructor() {
    registerLocaleData(localeEs, CURRENT_LOCALE_ID, localeExtraEs);
  }
}
